/* ============================================================================
   SYMEDIC — íconos profesionales
   Las pantallas usan emojis como íconos (✏️ 🗑 📥 ➕ 🔍 💾 🔬 … 77 distintos en
   429 lugares) y el menú lateral usa clases de Font Awesome que NUNCA se
   cargan (las casillas de las carpetas salían vacías). Este archivo:
     - quita el emoji del texto y pone en su lugar un ícono de línea, del mismo
       color que el texto, todos del mismo tamaño y grosor;
     - dibuja los íconos fa-* del menú con el mismo juego de íconos.
   No cambia ninguna pantalla: solo el texto ya pintado (sin quitar ni mover
   nodos, para no estorbar a React) y un atributo data-sym-ico.
   Íconos dibujados a mano en el estilo de Lucide (líneas de 2 px, 24×24).
   ============================================================================ */
(function () {
  if (window.__symIconos) return;
  window.__symIconos = true;

  /* ── juego de íconos (contenido de un <svg viewBox="0 0 24 24">) ───────── */
  var SVG = {
    editar: '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>',
    eliminar: '<path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/>',
    descargar: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/><path d="M12 15V3"/>',
    subir: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m17 8-5-5-5 5"/><path d="M12 3v12"/>',
    nuevo: '<path d="M12 5v14M5 12h14"/>',
    buscar: '<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>',
    filtro: '<path d="M3 4h18l-7 8.5V19l-4 2v-8.5Z"/>',
    guardar: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"/><path d="M17 21v-8H7v8"/><path d="M7 3v5h8"/>',
    alerta: '<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/>',
    ok: '<circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    cerrar: '<path d="M18 6 6 18M6 6l12 12"/>',
    laboratorio: '<path d="M9 3h6"/><path d="M10 3v6L4.6 18.4A1.8 1.8 0 0 0 6.2 21h11.6a1.8 1.8 0 0 0 1.6-2.6L14 9V3"/><path d="M7.5 15h9"/>',
    imprimir: '<path d="M6 9V3h12v6"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><path d="M6 14h12v7H6z"/>',
    empresa: '<rect x="4" y="3" width="16" height="18" rx="1"/><path d="M9 21v-4h6v4"/><path d="M8 7h2M14 7h2M8 11h2M14 11h2"/>',
    calendario: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/>',
    grafico: '<path d="M3 3v18h18"/><path d="M8 17v-6M13 17V7M18 17v-3"/>',
    ejecutar: '<path d="M7 4v16l13-8Z"/>',
    firmar: '<path d="M3 17c2.5-2 3.5-8 5.5-8s.5 7 2.5 7 2-3.5 4-3.5 1.5 2.5 6 2.5"/><path d="M3 21h18"/>',
    usuario: '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/>',
    usuarios: '<circle cx="9" cy="8" r="4"/><path d="M2 21a7 7 0 0 1 14 0"/><path d="M16 4a4 4 0 0 1 0 8M22 21a7 7 0 0 0-4-6.3"/>',
    identificacion: '<rect x="2" y="5" width="20" height="14" rx="2"/><circle cx="8" cy="12" r="2.5"/><path d="M14 10h5M14 14h4"/>',
    documento: '<path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z"/><path d="M14 3v6h6M8 13h8M8 17h6"/>',
    lista: '<rect x="5" y="4" width="14" height="18" rx="2"/><path d="M9 2h6v4H9z"/><path d="M9 11h6M9 15h6"/>',
    carpeta: '<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"/>',
    dinero: '<path d="M12 2v20"/><path d="M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>',
    factura: '<path d="M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2Z"/><path d="M9 8h6M9 12h6M9 16h3"/>',
    actualizar: '<path d="M21 12a9 9 0 1 1-2.6-6.4L21 8"/><path d="M21 3v5h-5"/>',
    anexo: '<path d="m21 11-8.5 8.5a5 5 0 0 1-7-7L14 4a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 7"/>',
    candado: '<rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>',
    llave: '<circle cx="7.5" cy="15.5" r="4.5"/><path d="m10.7 12.3 9.3-9.3M16 7l3 3M18.5 4.5l2 2"/>',
    enlace: '<path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/>',
    etiqueta: '<path d="M3 3h8l10 10-8 8L3 11Z"/><circle cx="7.5" cy="7.5" r="1.5"/>',
    imagen: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-5-5L5 21"/>',
    archivo: '<rect x="3" y="4" width="18" height="4" rx="1"/><path d="M5 8v11a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8"/><path d="M10 12h4"/>',
    reloj: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    salir: '<path d="M12 2v10"/><path d="M18.4 6.6a9 9 0 1 1-12.8 0"/>',
    ver: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>',
    correo: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>',
    limpiar: '<path d="m7 21-4.3-4.3a1 1 0 0 1 0-1.4l9.6-9.6a1 1 0 0 1 1.4 0l5.6 5.6a1 1 0 0 1 0 1.4L13 19"/><path d="M22 21H7M5 11l9 9"/>',
    ajustes: '<path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M2 14h4M10 8h4M18 16h4"/>',
    ubicacion: '<path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11Z"/><circle cx="12" cy="10" r="2.5"/>',
    maletin: '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M3 13h18"/>',
    numero: '<path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18"/>',
    monitor: '<rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>',
    escudo: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/>',
    herramientas: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.8-3.8a6 6 0 0 1-7.9 7.9l-6.9 6.9a2.1 2.1 0 0 1-3-3l6.9-6.9a6 6 0 0 1 7.9-7.9Z"/>',
    flecha: '<path d="m9 18 6-6-6-6"/>',
    casilla: '<rect x="3" y="3" width="18" height="18" rx="2"/><path d="m8 12 3 3 5-6"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 16v-4M12 8h.01"/>',
  };

  /* ── emoji → ícono ──────────────────────────────────────────────────────── */
  var POR_EMOJI = {
    "✏": "editar", "🖊": "editar", "🖋": "editar", "📝": "editar",
    "🗑": "eliminar", "🗙": "cerrar",
    "📥": "descargar", "⬇": "descargar", "📤": "subir", "⬆": "subir",
    "➕": "nuevo", "🆕": "nuevo",
    "🔍": "buscar", "🔎": "buscar",
    "💾": "guardar",
    "⚠": "alerta", "❗": "alerta", "❌": "cerrar", "✖": "cerrar", "❎": "cerrar",
    "✅": "ok", "✔": "check", "☑": "casilla",
    "🔬": "laboratorio", "🧪": "laboratorio", "🧫": "laboratorio", "🧬": "laboratorio", "🩸": "laboratorio",
    "🖨": "imprimir",
    "🏢": "empresa", "🏥": "empresa", "🏭": "empresa", "🏙": "empresa", "🏦": "empresa",
    "📅": "calendario", "📆": "calendario", "🗓": "calendario",
    "📊": "grafico", "📈": "grafico", "📉": "grafico",
    "▶": "ejecutar", "⏵": "ejecutar",
    "✍": "firmar",
    "👤": "usuario", "👨‍⚕": "usuario", "👩‍⚕": "usuario", "🩺": "usuario", "🧑": "usuario",
    "👥": "usuarios", "🪪": "identificacion",
    "📄": "documento", "📃": "documento", "🧾": "factura", "📑": "documento",
    "📋": "lista", "🗂": "carpeta", "📁": "carpeta", "📂": "carpeta",
    "💰": "dinero", "💵": "dinero", "💲": "dinero", "💳": "dinero", "💊": "dinero",
    "🔄": "actualizar", "🔃": "actualizar", "🔁": "actualizar",
    "📎": "anexo", "🔒": "candado", "🔐": "candado", "🔑": "llave", "🔗": "enlace",
    "🏷": "etiqueta", "🎟": "etiqueta", "🖼": "imagen", "📷": "imagen",
    "🗜": "archivo", "📦": "archivo",
    "🕐": "reloj", "⏳": "reloj", "⌛": "reloj", "⏰": "reloj",
    "⏻": "salir", "👁": "ver", "📧": "correo", "✉": "correo",
    "🧹": "limpiar", "⚙": "ajustes", "📍": "ubicacion", "💼": "maletin",
    "🔢": "numero", "📐": "numero", "ℹ": "info",
    "🟢": "punto-verde", "🟡": "punto-amarillo", "🔴": "punto-rojo", "🟠": "punto-amarillo", "🔵": "punto-azul",
    "👇": null, "👉": null, "✨": null, "🎉": null,
  };
  // el texto del botón manda sobre el emoji (📊 Exportar Excel = descargar)
  var POR_TEXTO = [
    [/^(exportar|excel|xls|descargar)/, "descargar"],
    [/^(filtro|filtros|filtrar)/, "filtro"],
    [/^limpiar/, "limpiar"],
    [/^firmar/, "firmar"],
    [/^(guardar|grabar)/, "guardar"],
    [/^imprimir/, "imprimir"],
    [/^(eliminar|borrar|quitar)/, "eliminar"],
    [/^(consultar|ejecutar)/, "buscar"],
  ];
  var TITULO = { editar: "Editar", eliminar: "Eliminar", descargar: "Descargar", subir: "Subir", nuevo: "Nuevo",
    buscar: "Buscar", filtro: "Filtros", guardar: "Guardar", imprimir: "Imprimir", ver: "Ver", anexo: "Anexos",
    firmar: "Firmar", actualizar: "Actualizar", cerrar: "Cerrar", ok: "Listo" };
  // íconos fa-* del menú lateral (la hoja de Font Awesome no se carga)
  var FA = { "fa-file-invoice-dollar": "factura", "fa-desktop": "monitor", "fa-clipboard-list": "lista",
    "fa-sliders-h": "ajustes", "fa-shield-alt": "escudo", "fa-tools": "herramientas", "fa-folder": "carpeta",
    "fa-chevron-right": "flecha", "fa-search": "buscar", "fa-edit": "editar", "fa-trash": "eliminar",
    "fa-trash-alt": "eliminar", "fa-plus": "nuevo", "fa-user": "usuario", "fa-sign-out-alt": "salir" };

  /* ── hoja de estilos con los íconos ─────────────────────────────────────── */
  function url(nombre) {
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round">' + SVG[nombre] + "</svg>";
    return 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
  }
  var css = [
    "[data-sym-ico]::before,i.fa[class*='fa-']::before{content:'';display:inline-block;width:1.08em;height:1.08em;",
    "flex-shrink:0;vertical-align:-.17em;background-color:currentColor;-webkit-mask:var(--sym-ico) center/contain no-repeat;",
    "mask:var(--sym-ico) center/contain no-repeat}",
    "[data-sym-ico]::before{margin-right:.45em}",
    "[data-sym-ico][data-sym-solo]::before{margin-right:0}",
    "i.fa[class*='fa-']{font-style:normal;display:inline-flex;align-items:center;justify-content:center}",
    "[data-sym-ico^='punto-']::before{-webkit-mask:none;mask:none;border-radius:50%;width:.6em;height:.6em;vertical-align:.05em}",
    "[data-sym-ico='punto-verde']::before{background:#1e9e5a}[data-sym-ico='punto-amarillo']::before{background:#d39e00}",
    "[data-sym-ico='punto-rojo']::before{background:#d64532}[data-sym-ico='punto-azul']::before{background:#1652a6}",
  ];
  Object.keys(SVG).forEach(function (n) { css.push("[data-sym-ico='" + n + "']{--sym-ico:" + url(n) + "}"); });
  Object.keys(FA).forEach(function (c) { css.push("i.fa." + c + "{--sym-ico:" + url(FA[c]) + "}"); });
  var estilo = document.createElement("style");
  estilo.id = "sym-iconos";
  estilo.textContent = css.join("\n");
  (document.head || document.documentElement).appendChild(estilo);

  /* ── quitar emojis del texto y marcar el ícono ──────────────────────────── */
  // pictogramas + selector de variación + uniones (👨‍⚕). Quedan como texto: flechas → ← ↩, ✓ y ●
  var EMOJI = "(?:[\\u{1F000}-\\u{1FAFF}\\u{2600}-\\u{2712}\\u{2714}-\\u{27BF}\\u{2B00}-\\u{2BFF}\\u{2300}-\\u{23FF}\\u{25A0}-\\u{25CE}\\u{25D0}-\\u{25FF}\\u{2139}]" +
              "(?:\\u{FE0F}|\\u{200D}[\\u{1F000}-\\u{1FAFF}\\u{2600}-\\u{27BF}])*)";
  var RE_HAY = new RegExp(EMOJI, "u");
  var RE_TODOS = new RegExp(EMOJI + "\\s*", "gu");
  var NO_TOCAR = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1 };

  function iconoPara(emoji, texto) {
    var t = (texto || "").toLowerCase().trim();
    for (var i = 0; i < POR_TEXTO.length; i++) if (POR_TEXTO[i][0].test(t)) return POR_TEXTO[i][1];
    var base = emoji.replace(/️/g, "");
    if (Object.prototype.hasOwnProperty.call(POR_EMOJI, base)) return POR_EMOJI[base];
    var primero = Array.from(base)[0];
    if (Object.prototype.hasOwnProperty.call(POR_EMOJI, primero)) return POR_EMOJI[primero];
    return null;
  }
  function esPrimerTexto(nodo) {
    for (var n = nodo.parentNode.firstChild; n && n !== nodo; n = n.nextSibling) {
      if (n.nodeType === 1 && !n.hasAttribute("data-sym-ico") && (n.textContent || "").trim()) return false;
      if (n.nodeType === 3 && n.nodeValue.trim()) return false;
    }
    return true;
  }
  var RE_MAS = /^\s*\+\s+(?=\S)/;   // "+ Nueva Empresa" en un botón
  function procesar(nodo) {
    var v = nodo.nodeValue;
    if (!v) return;
    var padre = nodo.parentElement;
    if (padre && RE_MAS.test(v) && padre.closest("button, .btn") && !padre.hasAttribute("data-sym-ico") && esPrimerTexto(nodo)) {
      nodo.nodeValue = v.replace(RE_MAS, "");
      padre.setAttribute("data-sym-ico", "nuevo");
      return;
    }
    if (!RE_HAY.test(v)) return;
    if (!padre || NO_TOCAR[padre.tagName] || padre.closest("svg, [contenteditable='true']")) return;
    var m = v.match(new RegExp(EMOJI, "u"));
    var alInicio = v.slice(0, m.index).trim() === "";
    var limpio = v.replace(RE_TODOS, "").replace(/\s{2,}/g, " ");
    if (alInicio) limpio = limpio.replace(/^\s+/, "");
    var primero = esPrimerTexto(nodo) && alInicio;
    nodo.nodeValue = limpio;
    if (padre.tagName === "OPTION" || padre.tagName === "TITLE" || !primero || padre.hasAttribute("data-sym-ico")) return;
    var nombre = iconoPara(m[0], padre.textContent);
    if (!nombre) return;
    padre.setAttribute("data-sym-ico", nombre);
    if (!padre.textContent.trim()) {
      padre.setAttribute("data-sym-solo", "1");
      if (!padre.getAttribute("title") && TITULO[nombre]) padre.setAttribute("title", TITULO[nombre]);
    }
  }
  function recorrer(raiz) {
    if (!raiz) return;
    if (raiz.nodeType === 3) { procesar(raiz); return; }
    if (raiz.nodeType !== 1 || NO_TOCAR[raiz.tagName]) return;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var lista = [];
    for (var n = w.nextNode(); n; n = w.nextNode()) if (RE_HAY.test(n.nodeValue) || RE_MAS.test(n.nodeValue)) lista.push(n);
    lista.forEach(procesar);
  }
  if (document.title && RE_HAY.test(document.title)) document.title = document.title.replace(RE_TODOS, "");

  var pendientes = [];
  var agendado = false;
  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      var c = cambios[i];
      if (c.type === "characterData") pendientes.push(c.target);
      else for (var j = 0; j < c.addedNodes.length; j++) pendientes.push(c.addedNodes[j]);
    }
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      var lote = pendientes; pendientes = [];
      lote.forEach(function (n) { if (n.isConnected) recorrer(n); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  function iniciar() { recorrer(document.body); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar);
  else iniciar();
})();
